import { render, staticRenderFns } from "./bonus-detail-add.vue?vue&type=template&id=20a35981&"
import script from "./bonus-detail-add.vue?vue&type=script&lang=js&"
export * from "./bonus-detail-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports